export interface SendPayload {
  position: string;
  shifts: number[];
  pay_rate: string;
  notes: string;
}

export const leadsFilter = {
  inhouse: 'inhouse',
  agency: 'by-agency',
} as const;

export type LeadsProps = {
  filter: (typeof leadsFilter)[keyof typeof leadsFilter];
};
